import { Action as ReduxAction } from 'redux';
import { isType } from 'typescript-fsa';
import { ClearDncStatus, GetDncStatus } from '../actions/compliance_actions';

export type ComplianceRecord = Record<string, {
        canContact: boolean;
        isDnc?: boolean;
        reason: string;
        loading: boolean;
}> 
export interface ComplianceState {
    byPhone: ComplianceRecord;
}

const initialState: ComplianceState = {
    byPhone: {}
};

export function complianceReducer(
    state: ComplianceState = initialState,
    action: ReduxAction
): ComplianceState {    
    if (isType(action, GetDncStatus.done)) {        
        const { phone, canContact, isDnc, reason } = action.payload.result;

        return {
            ...state,
            byPhone: {
                ...state.byPhone,
                [phone]: {
                    canContact,
                    isDnc,
                    reason,
                    loading: false,
                },
            },
        };
    } else if (isType(action, GetDncStatus.started)) {        
        const { phone } = action.payload;
        return {
            ...state,
            byPhone: {
                ...state.byPhone,
                [phone]: {
                    loading: true,
                    canContact: false,
                    reason: '',
                },
            },
        };
    } else if (isType(action, GetDncStatus.failed)) {
        const phone = action.payload.params.phone;
        return {
            ...state,
            byPhone: {
                ...state.byPhone,
                [phone]: {
                    canContact: false,
                    isDnc: true,
                    reason: 'Error fetching phone status',
                    loading: false,
                }
            }
        }
    } else if (isType(action, ClearDncStatus)) {
        return {
            ...state,
            byPhone: {}
        };
    }

    return state;
}
